export default __webpack_public_path__ + "static/5-d4759cf83a380252ca69e9613a68a5e1.jpg";